import styled from 'styled-components';

import {colors} from '@app/styles/theme';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const ControlsCard = styled.div`
    padding: 16px;
    background: ${colors.white};
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.15);
`;

export const SearchBox = styled.div`
    width: 100%;
    max-width: 550px;
`;

export const TaxpayerCell = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
`;

export const SurMarker = styled.span<{color: string}>`
    margin-top: 3px;
    width: 12px;
    height: 12px;
    border-radius: 3px;
    background: ${({color}) => color};
    flex: 0 0 auto;
`;

export const TaxpayerNameButton = styled.button`
    border: 0;
    background: transparent;
    padding: 0;
    color: ${colors.brandPrimary};
    cursor: pointer;
    font: inherit;
    text-align: left;
`;

export const TinText = styled.div`
    margin-top: 4px;
    color: ${colors.textSecondary};
    font-size: 12px;
`;
